export class User {
  constructor() {
    this.id = null;
    this.firstName = null;
    this.lastName = null;
    this.email = null;
    this.avatar = null;
    this.phone = null;
    this.address = null;
    this.verified = null;
    this.company = '';
    this.roles = [];
    this.iscompleted = false;
  }

  map(_user) {
    if (_user.id) {
      this.id = _user.id;
    }
    if (_user.first_name) {
      this.firstName = _user.first_name;
    }
    if (_user.last_name) {
      this.lastName = _user.last_name;
    }
    if (_user.email) {
      this.email = _user.email;
    }

    if (_user.phone) {
      this.phone = _user.phone;
    }

    if (_user.address) {
      this.address = _user.address;
    }

    if (_user.avatar) {
      this.avatar = _user.avatar;
    }

    if (!!_user.email_verified_at) {
      this.verified = true;
    }

    if (_user.company) {
      this.company = _user.company;
    }

    if (_user.caterer_id) {
      this.catererId = _user.caterer_id;
    }

    if (_user.roles) {
      this.roles = _user.roles;
    }

    if (_user.is_completed) {
      this.iscompleted = _user.is_completed;
    }

    return this;
  }

  update(user) {
    if (user.verified) {
      this.verified = true;
    }

    return this;
  }
}
